module.exports = "data:image/png;base64,UklGRkAAAABXRUJQVlA4TDQAAAAvP8APEB8wzPMf8x+gAraRJDVCa5Gazg+b6MjgzfP23Yj+TwCDv22ixu9cYsDvfcT6Pxj8"